import React from "react";
import ReactDOM from "react-dom/client";
import App from "./app";
import ErrorBoundary from "./components/error-boundary";
import "./scss/CardiographReport.scss";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <ErrorBoundary>
        <App />
    </ErrorBoundary>
);
